var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangebuttonRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.63,
    y1: 101.19,
    x2: 153.65,
    y2: -17.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47a4d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DESIGN_copy",
    "data-name": "DESIGN copy"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 194,
    height: 89,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.9,
    y: 5.9,
    width: 176.47,
    height: 71.56,
    rx: 8.49
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangebuttonRectangle);
export default __webpack_public_path__ + "static/media/Orange button Rectangle.e08530919ccdef966d8464daffdde94e.svg";
export { ForwardRef as ReactComponent };